import Moment from 'moment';
import _ from 'lodash';

const MatchService = {

    getCompetitionLogo: function (competition) {
        switch (competition) {
            case "Serie A ENILIVE":
                return require('@/assets/media/serie-a.png')
            case "Serie C":
                return require('@/assets/media/serie-c.png')
            case "Champions League":
                return require('@/assets/media/champions.png')
            default:
                return require('@/assets/media/logo.svg')
        }
    },


};

export default MatchService;
